import { addDividerToMultipleLengthValue, vuexEventPathGenerator, } from '@/utils';
export const getterType = {
    getterSelectedHubName: 'getterSelectedHubName',
    getterSelectedHubId: 'getterSelectedHubId',
    getterIsSelectedHubInCheckedHubList: 'getterIsSelectedHubInCheckedHubList',
    getterHubList: 'getterHubList',
    getterHubSearchQuery: 'getterHubSearchQuery',
    getterFilteredHubList: 'getterFilteredHubList',
    getterHubCheckedList: 'getterHubCheckedList',
    getterHubCheckedIdList: 'getterHubCheckedIdList',
    getterHubHeaderLengthInfo: 'getterHubHeaderLengthInfo',
    getterStoreList: 'getterStoreList',
    getterStoreSearchQuery: 'getterStoreSearchQuery',
    getterFilteredStoreList: 'getterFilteredStoreList',
    getterStoreCheckedList: 'getterStoreCheckedList',
    getterStoreCheckedIdList: 'getterStoreCheckedIdList',
    getterStoreHeaderLengthInfo: 'getterStoreHeaderLengthInfo',
};
export const operationSettingGetterType = vuexEventPathGenerator(getterType, 'operationSetting');
const getter = {
    [getterType.getterSelectedHubName]: (state) => state.hub.selectedHub?.name,
    [getterType.getterSelectedHubId]: (state, _, rootState) => state.hub.selectedHub?.code ?? rootState.user.hubInfo.code,
    /** 선택한 허브가 채크리스트에 포함되어 있는지 여부 */
    [getterType.getterIsSelectedHubInCheckedHubList]: (_, { getterHubCheckedList, getterSelectedHubId, }) => getterHubCheckedList.find(({ code }) => code === getterSelectedHubId),
    [getterType.getterHubList]: ({ hub }) => hub.list ?? [],
    [getterType.getterHubSearchQuery]: ({ hub }) => hub.searchQuery,
    [getterType.getterFilteredHubList]: ({ hub }, { getterHubList }) => {
        const query = hub.searchQuery;
        if (!query) {
            return getterHubList;
        }
        return getterHubList.filter(({ name }) => name.includes(query));
    },
    [getterType.getterHubCheckedList]: (state) => state.hub.checkedList ?? [],
    [getterType.getterHubCheckedIdList]: (_, { getterHubCheckedList }) => getterHubCheckedList.map((hub) => hub.code),
    [getterType.getterHubHeaderLengthInfo]: (state, { getterHubCheckedList, getterFilteredHubList }) => {
        const res = addDividerToMultipleLengthValue(getterHubCheckedList, getterFilteredHubList);
        return `(${res})`;
    },
    [getterType.getterStoreList]: ({ store }) => store.list ?? [],
    [getterType.getterStoreSearchQuery]: ({ store }) => store.searchQuery,
    [getterType.getterFilteredStoreList]: ({ store }, { getterStoreList }) => {
        const query = store.searchQuery;
        if (!query) {
            return getterStoreList;
        }
        return getterStoreList.filter(({ name }) => name.includes(query));
    },
    [getterType.getterStoreCheckedList]: (state) => state.store.checkedList ?? [],
    [getterType.getterStoreCheckedIdList]: (_, { getterStoreCheckedList }) => (getterStoreCheckedList.map((store) => store.code)),
    [getterType.getterStoreHeaderLengthInfo]: (state, { getterStoreCheckedList, getterFilteredStoreList }) => {
        const res = addDividerToMultipleLengthValue(getterStoreCheckedList, getterFilteredStoreList);
        return `(${res})`;
    },
};
export default getter;
